import { observable } from "mobx";
import { Type } from "class-transformer";
import type { IRefundForRefundOfRefundWithPayment } from "./types";
import RefundForRefundOfRefundPaymentResponse from "./refundForRefundOfRefundPaymentResponse";
import RefundChargeResponse from "./refundChargeResponse";
import RefundPermittedActionsResponse from "./refundPermittedActionsResponse";
import RefundApprovalResponse from "./refundApprovalResponse";
import RefundOriginalTransferPaymentResponse from "./refundOriginalTransferPaymentResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class RefundForRefundOfRefundResponse {
  id!: string;

  @observable
  refundPaymentTemplateId!: string;

  @observable
  refundAmount!: number;

  @observable
  @Type(() => RefundChargeResponse)
  charge?: RefundChargeResponse;

  @observable
  @Type(() => RefundPermittedActionsResponse)
  permittedActions!: RefundPermittedActionsResponse;

  @observable
  @Type(() => RefundApprovalResponse)
  approvals!: RefundApprovalResponse[];

  @observable
  originalRefundOfficialRecordId?: string;

  @observable
  @Type(() => RefundOriginalTransferPaymentResponse)
  originalPayment!: RefundOriginalTransferPaymentResponse;
}

export default class RefundForRefundOfRefund
  extends RefundForRefundOfRefundResponse
  implements IRefundForRefundOfRefundWithPayment
{
  @observable
  refundPayment: RefundForRefundOfRefundPaymentResponse;

  @observable
  isSelectable: boolean;
}
